import { PROfileExperience, PROfileExperienceSkeleton } from "domains/pros/components/PROfileExperience";
import type React from "react";
import { usePROfileExperience } from "./hooks";

type PROfileExperienceContainerProps = { id: number };

export const PROfileExperienceContainer: React.FC<PROfileExperienceContainerProps> = ({ id }) => {
  const transformedData = usePROfileExperience({ proId: id });
  return transformedData ? <PROfileExperience data={transformedData} /> : <PROfileExperienceSkeleton />;
};
